import { observer } from "mobx-react-lite"
import i from "../../../../translations/i";
import React from "react";
import { useParams } from "react-router-dom";
import { ParamTypes } from "../../../../helpers/types.interfaces";
import { FunctionComponent } from "../../../../components/FunctionComponent/FunctionComponent";

const toBool = (value: any) => value === true || value === 1 || value === '1'

const normalizeModifier = (data: any) => {
    const groups = Array.isArray(data.groups)
        ? data.groups.map((group: any) => typeof group === 'object' ? group.id : group)
        : []

    return {
        ...data,
        enabled: data.enabled === true || data.enabled === 1 || data.enabled === '1',
        required: data.required === true || data.required === 1 || data.required === '1',
        countable: data.countable === true || data.countable === 1 || data.countable === '1',
        hidden: data.hidden === true || data.hidden === 1 || data.hidden === '1',
        groups,
        product_id: data.product_id ?? null,
        _product_link: !!data.product_id,
        _product: data.product ?? null,
    }
}

export const Modifier = observer(() => {

    const { id }: any = useParams<ParamTypes>()

    return (
        <FunctionComponent
            options={{
                title: i.t('modifier:editTitle'),
                buttons: [
                    { title: i.t('def:actions.backList'), href: `/shop/modifiers`, type: 'dashed' },
                    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
                ],
                model: {
                    id: null,
                    enabled: true,
                    name: '',
                    required: false,
                    countable: false,
                    min_count: 0,
                    max_count: 0,
                    default_count: 0,
                    free_count: 0,
                    price: 0,
                    hidden: false,
                    id_crm: '',
                    sorting: 500,
                    groups: [],
                    image: null,
                    image_uri: '',
                    remove_image: false,
                    product_id: null,
                    _product_link: false,
                    _product: null,
                },
                formAction: {
                    path: '/modifiers',
                    isId: true,
                    method: 'post',
                    result: {
                        redirect: '/shop/modifiers',
                        notification: {
                            message: i.t('def:success.complete'),
                            description: i.t('def:success.edit')
                        }
                    }
                },
                items: [
                    {
                        type: 'form',
                        requestData: (id && id > 0) ? {
                            method: 'get',
                            path: `/modifiers/${id}`,
                            isId: true,
                            entity: 'model',
                            prepareData: normalizeModifier,
                        } : null,
                        fields: [
                            {
                                type: 'switch',
                                items: [
                                    { name: 'enabled', label: i.t('def:active') },
                                    { name: 'required', label: i.t('modifier:required') },
                                    { name: 'countable', label: i.t('modifier:countable') },
                                    { name: 'hidden', label: i.t('modifier:hidden') },
                                    // { name: '_product_link', label: 'Связь с товаром', clearFields: ['product_id', '_product'] },
                                ],
                            },
                            {
                                type: 'input',
                                name: 'name',
                                span: 12,
                                label: i.t('def:name')
                            },
                            {
                                type: 'input',
                                name: 'id_crm',
                                span: 12,
                                label: i.t('def:id_crm')
                            },
                            {
                                type: 'select',
                                name: 'groups',
                                span: 24,
                                label: i.t('modifier:groups'),
                                multiple: true,
                                requestData: {
                                    method: 'get',
                                    path: '/modifiers_groups',
                                    entity: 'lists',
                                    prepareData: (data: any) => Array.isArray(data) ? [...data].reverse() : data
                                },
                                dataLabels: {
                                    label: 'name',
                                    id: 'id'
                                }
                            },
                            {
                                type: 'product_modal',
                                name: 'product_id',
                                elementName: '_product',
                                span: 24,
                                label: i.t('modifier:linkedProduct'),
                                visible: (model: any) => model._product_link,
                            },
                            {
                                type: 'number',
                                name: 'min_count',
                                span: 8,
                                label: i.t('modifier:minCount')
                            },
                            {
                                type: 'number',
                                name: 'max_count',
                                span: 8,
                                label: i.t('modifier:maxCount')
                            },
                            {
                                type: 'number',
                                name: 'default_count',
                                span: 8,
                                label: i.t('modifier:defaultCount')
                            },
                            {
                                type: 'number',
                                name: 'free_count',
                                span: 8,
                                label: i.t('modifier:freeCount')
                            },
                            {
                                type: 'number',
                                name: 'price',
                                span: 8,
                                label: i.t('modifier:price')
                            },
                            {
                                type: 'number',
                                name: 'sorting',
                                span: 8,
                                label: i.t('modifier:sorting')
                            },
                            {
                                type: 'input',
                                name: 'image_uri',
                                span: 24,
                                label: i.t('modifier:imageLink')
                            },
                            {
                                type: 'switch',
                                items: [
                                    { name: 'remove_image', label: i.t('modifier:removeImage') },
                                ],
                            },
                            {
                                type: 'file',
                                name: 'image',
                                span: 24,
                                label: i.t('def:image.image')
                            },
                        ],
                    },
                ]
            }}
            form={true}
        />
    )
})